import React from 'react'
import './PrimaryButton.css'

export default function PrimaryButton({ children, onClick, disabled, style }) {
  return (
    <button
      className={'ui-primary-btn' + (disabled ? ' ui-primary-btn--disabled' : '')}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  )
}
